export default "__VITE_ASSET__CCXFDcgr__"